import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import { ClientCategoriesSelect } from "../../../components/forms/AutoCompleteFormItem";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { useClientCategories } from "../../../hooks";
import { useIntl } from "react-intl";

const ClientDetails = (props) => {
  const { values, changeIsBtl, isPrivate } = props;
  const [isbtl, setIsBtl] = useState(null);
  const clientCategories = useClientCategories();
  const intl = useIntl();

  useEffect(() => {
    const client = clientCategories.filter(
      (item) => item.id === values.category_id
    )[0];
    if (client) {
      setIsBtl(client.name === "ביטוח לאומי");
      changeIsBtl(client.name === "ביטוח לאומי");
    }
  }, [changeIsBtl, clientCategories, values.category_id]);

  const onClientTypeChanged = (change) => {
    const item = clientCategories.filter((i) => i.id === change)[0];
    setIsBtl(item && item.name === "ביטוח לאומי");
    changeIsBtl(item && item.name === "ביטוח לאומי");
  };

  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col span={11}>
          <AnimationChildWrapper itemKey={1}>
            {isPrivate ? (
              <ReadOnlyItem
                content={intl.formatMessage({
                  id: "app.forms.client.private",
                })}
                name="category_id"
                category="client"
              />
            ) : (
              <ClientCategoriesSelect
                name="category_id"
                category="client"
                extraParams={
                  isPrivate
                    ? {
                        filter: { allow_branch_client: true },
                      }
                    : {}
                }
                onChange={onClientTypeChanged}
                required={true}
              />
            )}
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={2}>
            <PhoneNumberItem name="phone_number" category="client" />
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={3}>
            <InputItem name="email" email={true} category="client" />
          </AnimationChildWrapper>

          {isbtl ? (
            <AnimationChildWrapper itemKey={4}>
              <InputItem
                required={true}
                name="specific_data.comittee_name"
                category="client"
              />
            </AnimationChildWrapper>
          ) : null}
          {isbtl ? (
            <AnimationChildWrapper itemKey={5}>
              <InputItem
                required={true}
                name="specific_data.organization_branch_number"
                category="client"
                number={true}
              />
            </AnimationChildWrapper>
          ) : null}
        </Col>
        <Col span={11} offset={2}>
          <AnimationChildWrapper itemKey={6}>
            <InputItem name="name" required={true} category="client" />
          </AnimationChildWrapper>

          <AnimationChildWrapper itemKey={7}>
            <PhoneNumberItem name="fax_number" category="client" />
          </AnimationChildWrapper>

          {isbtl ? (
            <AnimationChildWrapper itemKey={8}>
              <InputItem
                required={true}
                name="specific_data.comittee_number"
                category="client"
                number={true}
              />
            </AnimationChildWrapper>
          ) : null}

          {isbtl ? (
            <AnimationChildWrapper itemKey={9}>
              <InputItem
                required={true}
                name="specific_data.organization_branch_name"
                category="client"
              />
            </AnimationChildWrapper>
          ) : null}
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default ClientDetails;
